// Popup.js
import React from 'react';
import '../../styles/Popup.css';
import { GetGame, IsValid, FetchAccountInfo, GetAuthStatus, GetTagInfo, GetDeveloperInfo } from "../../Utilities";
import { useEffect, useState } from "react";
import webContentStrings from "./../../ContentStrings/LocalizedStrings.js";
//import { Thumbnail } from 'react-native-thumbnail-video';

export const MediaType = {
    PHOTO: '0',
    YOUTUBEVID: '1',
}

//<div className="popup-filter" />

const Popup = ({ handleClick, gameId, gameData}) => {
    const REACT_APP_S3_BASE_URL = process.env.REACT_APP_S3_BASE_URL;

    var [internalData, setInternalData] = useState(gameData || {});
    var Name, Description, SteamLink, EpicLink, MediaEntries = null;
    const [selectedMedia, setSelectedMedia ] = useState(-1);
    const [MediaTable, setMediaTable] = useState([]);
    const [accountInfo, setAccountInfo] = useState(null);
    const [subscriptionInfo, setSubscriptionInfo] = useState(null);
    const [mediaBigScreenURL, setMediaBigScreenURL] = useState("");
    const [authStatus, setAuthStatus] = useState();
    const [tagData, setTagData] = useState([]);
    const [developer, setDeveloper] = useState([]);

    useEffect(() => {
        if (IsValid(MediaTable) !== true || MediaTable.length < 1 || selectedMedia < 0) return;

        if (MediaTable[selectedMedia].type.toString() === MediaType.PHOTO) {
            if (MediaTable[selectedMedia].URL.substr(0, 4) !== "http") {
                setMediaBigScreenURL(process.env.REACT_APP_S3_BASE_URL + MediaTable[selectedMedia].URL);
            }
            else {
                setMediaBigScreenURL(MediaTable[selectedMedia].URL);
            }
        }
    }, [selectedMedia]);

    useEffect(() => {
        GetGame(gameId).then((data) => {
            if (IsValid(data) === true && data.success === true) {
                setInternalData(data.message);
            }
        });
    }, [gameId])

    useEffect(() => {
        setAuthStatus(GetAuthStatus());

        GetTagInfo(internalData.TagId).then((data) => {
            setTagData([...data]);
        })
    }, []);

    useEffect(() => {
        GetDeveloperInfo(internalData.DeveloperID).then((data) => {
            if (IsValid(data) === true && data.success === true) {
                setDeveloper(data.message);
                console.log(data.message.MediaEntries);
                setMediaTable(JSON.parse(internalData.MediaEntries));
                setSelectedMedia(0);
            }
        })
    }, [internalData]);

    useEffect(() => {
        if (authStatus === true) {
            FetchAccountInfo(setAccountInfo);
        }
    }, [authStatus]);

    useEffect(() => {
        if (IsValid(accountInfo) === true) {
            var subURL = process.env.REACT_APP_NODE_ADDRESS + "/GetSubscription";
            const subReqOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ 'customer': accountInfo.StripeId })
            };

            fetch(subURL, subReqOptions)
                .then((res) => res.json())
                .then((data) => {
                    //console.log(data);
                    if (data.success === true) {
                        //console.log(data.message);
                        setSubscriptionInfo(data.message);
                        console.log(data.message);
                    }
                    else {
                        setSubscriptionInfo(false);
                    }
                });
        }
    }, [accountInfo])

    //const fullPhotoUrl = `${REACT_APP_S3_BASE_URL}${BackgroundUrl}`
    //<img src={fullPhotoUrl} alt="Game cover" />
    return (
        <div className="popup-screen-cover">
            <div className="popup-card">
                <div className="gameInfoTopRow">

                    <div className="gameTitleInformation">
                        <div className="popup-card-title">
                            <text>{internalData.Name}</text>
                        </div>
                        <div className='popup-card-dev-info'>
                            <div className='popup-card-studio-div'>
                                <p className="popup-card-studio">{ webContentStrings.libraryStrings.studioTitle + ':'}</p>
                                <p className="popup-card-studio-name">{internalData.DeveloperNameOverride || developer.DevName}</p>
                            </div>
                            {internalData.PublisherName !== undefined && internalData.PublisherName !== "" && internalData.PublisherName !== null && <div className='popup-card-publisher-div'>
                                <p className="popup-card-publisher">{webContentStrings.libraryStrings.publisherTitle + ':'}</p>
                                <p className="popup-card-publisher-name">{internalData.PublisherName}</p>
                            </div>}
                        </div>
                        <div>
                            {IsValid(tagData) === true && tagData.map((tag, index) => (
                                <span className="popup-tag">{tag}</span>
                            ))}
                        </div>
                    </div>

                    <div className="gameMediaSection">
                        {IsValid(MediaTable) === true && selectedMedia >= 0 && <div className="gameMediaBigScreen">
                            {
                                MediaTable[selectedMedia].type.toString() === MediaType.PHOTO && <img src={mediaBigScreenURL.replace(' ', '%20')} />
                            }
                            {
                                MediaTable[selectedMedia].type.toString() === MediaType.YOUTUBEVID && <iframe src={MediaTable[selectedMedia].URL} />
                            }
                        </div>}
                        <hr/>
                        {IsValid(MediaTable) === true && <div className="gameMediaSelector">
                            {
                                MediaTable.map((entry, index) => {
                                    return <MediaSelectorItem EntryInfo={entry} Index={index} UpdateSelected={setSelectedMedia} Selected={selectedMedia === index} />;
                                })
                            }
                        </div>}
                    </div>
                </div>

                <div className="popup-text">

                    <div className='popup-text-content'>
                        <p className="popup-card-description">{internalData.Description}</p>
                    </div>
                    {(IsValid(internalData.SteamLink) === true || IsValid(internalData.EpicLink) === true) && <div className="popup-platform-logos">
                        <p className="gameCardLinksTitle">Links</p>
                        {IsValid(internalData.SteamLink) === true && (
                            <a href={internalData.SteamLink} target="_blank" rel="noopener noreferrer">
                                <img
                                    src={'/steamIcon.png'}
                                    alt="Steam"
                                    className="platform-logo"
                                    style={{ width: 30, height: 30 }}
                                />
                            </a>
                        )}
                        {IsValid(internalData.EpicLink) === true && (
                            <a href={internalData.EpicLink} target="_blank" rel="noopener noreferrer">
                                <img
                                    src={`epicIcon.png`}
                                    alt="Epic"
                                    className="platform-logo"
                                    style={{ width: 30, height: 35 }}
                                />
                            </a>
                        )}
                    </div>}
                </div>

                {(IsValid(accountInfo) === true && ((IsValid(subscriptionInfo) === true && subscriptionInfo !== false) || internalData.Freeplay === 1)) && <div className="gamePopupDownloadEntries">
                    <p className="gamePopupDownloadTitle">Downloads</p>
                    {JSON.parse(internalData.PublicBuildLinks).map((link, index) => {
                        return <div className="downloadLinkListing">
                            <a className="gameDownloadLink" href={process.env.REACT_APP_S3_BASE_URL + link} download>{link.split('/').pop()}</a>
                            {link === internalData.WindowsBuild && <img className="gameDownloadPlatformImg" src="/windows.png" />}
                            {link === internalData.LinuxBuild && <img className="gameDownloadPlatformImg" src="/linux-logo.png" />}
                            {link === internalData.MacBuild && <img className="gameDownloadPlatformImg" src="/mac-os-logo.png" />}
                        </div>
                    })}
                </div>}

                {IsValid(accountInfo) !== true &&
                    <button class="gameAccessButton" onClick={() => window.location.assign("/login?page=signUp")}>Sign Up To Play</button>
                }

                {IsValid(accountInfo) === true && IsValid(subscriptionInfo) === true && subscriptionInfo === false && internalData.Freeplay !== 1 &&
                    <button class="gameAccessButton" onClick={() => window.location.assign("/account/subscription")}>Start Your Subscription To Play</button>
                }

                <div className="close-btn" onClick={handleClick}><img src={`${process.env.PUBLIC_URL}/xbutton.svg`} /></div>
                
            </div>
        </div >
    );
};

/*
    
*/

const MediaSelectorItem = (({ EntryInfo, Index, UpdateSelected, Selected }) => {
    const [thumbnailURL, setThumbnailURL] = useState("");

    function ImgClicked() {
        UpdateSelected(Index);
    };

    useEffect(() => {
        console.log(EntryInfo.type.toString() === MediaType.PHOTO);

        if (EntryInfo.type.toString() === MediaType.YOUTUBEVID) {
            var vidId = EntryInfo.URL;
            vidId = vidId.split("/");
            console.log(vidId);
            vidId = vidId[vidId.length-1].split("?")[0];
            setThumbnailURL("https://img.youtube.com/vi/" + vidId + "/hqdefault.jpg");
        }

        if (EntryInfo.type.toString() === MediaType.PHOTO) {
            if (EntryInfo.URL.substr(0, 4) !== "http") {
                setThumbnailURL(process.env.REACT_APP_S3_BASE_URL + EntryInfo.URL);
            }
            else {
                setThumbnailURL(EntryInfo.URL);
            }
        }
    }, [EntryInfo.URL, EntryInfo.type]);
   
    return (
        <div className="gameMediaEntryDiv">
            {EntryInfo.type.toString() === MediaType.PHOTO && <img className={"gameMediaSelectorEntry " + (Selected ? "gameMediaSelected" : "")} src={thumbnailURL.replace(' ','%20')} onClick={ImgClicked} /> }
            {EntryInfo.type.toString() === MediaType.YOUTUBEVID && <img className={"gameMediaSelectorEntry " + (Selected ? "gameMediaSelected" : "")} src={thumbnailURL} onClick={ImgClicked} />}
        </div>
    );
});

export default Popup;